module.exports = __webpack_public_path__ + "static/media/violon.ed964ed0.jpg";